import React from 'react';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './components/Login';
import WorkerView from './components/WorkerView';
import AdminView from './components/AdminView';

function AppContent() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-mgh-blue-900 flex items-center justify-center">
        <div className="text-center text-white">
          <div className="text-5xl font-black mb-2">MGH</div>
          <div className="text-lg opacity-75">Cargando...</div>
          <div className="mt-4 w-8 h-8 border-4 border-white border-t-transparent rounded-full animate-spin mx-auto" />
        </div>
      </div>
    );
  }

  if (!user) return <Login />;
  if (user.rol === 'admin') return <AdminView />;
  return <WorkerView />;
}

export default function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}
